/** Stable CMS item ids (shared by editors and empty default shapes). */

export const TRUST_BAR_IDS = ["rpm-ccm", "hipaa", "encryption", "realtime", "devices"];

export const FEATURE_IDS = [
  "vital-monitoring",
  "mobile-app",
  "alerts",
  "reports",
  "care-plans",
  "communication",
  "fax",
  "devices",
  "hipaa-login",
];

export const STEP_IDS = ["onboard", "track", "monitor", "action"];

export const ROLE_IDS = ["organizations", "providers", "staff", "patients"];

export const ABOUT_FEATURE_IDS = ["mission", "what-we-do", "what-we-provide"];

export const SOLUTIONS_SMART_IDS = [
  "rpm",
  "care-management",
  "patient-engagement",
  "operational-efficiency",
];

export const SOLUTIONS_ALT_IDS = ["rpm-simple", "care-coordination", "integrations"];

export const DEVICE_IDS = [
  "blood-pressure-monitor",
  "pulse-oximeter",
  "glucose-analyzer",
  "weight-scale",
];

export const CONTACT_INFO_IDS = ["phone", "email", "headquarters"];

export const CONTACT_FIELD_IDS = ["fullName", "email", "mobile", "organization", "message"];
